export const generateTimeOptions = (): { time: string; displayTime: string }[] => {
  const options: { time: string; displayTime: string }[] = [];

  const createOption = (hour: number, minute: number) => {
    const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:00`;

    const tempDate = new Date();
    tempDate.setHours(hour, minute, 0, 0);

    const displayTime = tempDate.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short'
    });

    return { time, displayTime }
  }

  for (let hour = 0; hour < 24; hour++) {
    options.push(createOption(hour, 0));
    options.push(createOption(hour, 15));
    options.push(createOption(hour, 30));
    options.push(createOption(hour, 45));
  }

  return options;
};

export const parseDateTime = (isoString?: string): { date: string; time: string } => {
  if (!isoString) {
    return { date: '', time: '' };
  }

  try {
    const dateObj = new Date(isoString);

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const date = `${year}-${month}-${day}`;

    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');
    const time = `${hours}:${minutes}:${seconds}`;

    return { date, time };
  } catch {
    return { date: '', time: '' };
  }
};

export const formatDateTime = (date: string, time: string): string => {
  if (!date || !time) {
    return '';
  }
  return new Date(`${date}T${time}`).toISOString();
};


